export default (client, defaultParams) => ({
  get: (hash) => (
    client(`/course/${hash}`, {
      method: 'GET',
      params: {
        ...defaultParams,
      },
    })
  ),
  all: () => (
    client('/courses', {
      method: 'GET',
      params: {
        ...defaultParams,
      },
    })
  ),
  update: (hash, data) => (
    client(`/course/${hash}`, {
      method: 'PUT',
      data,
      params: {
        ...defaultParams,
      },
    })
  ),
  remove: (hash) => (
    client(`/course/${hash}`, {
      method: 'DELETE',
      params: {
        ...defaultParams,
      },
    })
  ),
  create: (data) => (
    client('/courses', {
      method: 'POST',
      data,
      params: {
        ...defaultParams,
      },
    })
  ),

  getMessage: (k) => {
    const messages = {
    };
    return (messages[k] || k);
  },
});
